const langList = {
    Yin: {
        lang: "Yin",
        hello: "Apa kabar",
        today: "Hari ini",
        dayword: "Sepatah kata sehari",
        holiday: "Hari libur",
        holidaySub: "Liburan masih jauh..",
        confirm: "Yakin",
        day: "hari",
        days: "hari",
        weeksRow: [
            { id: 0, name: "Min" },
            { id: 1, name: "Sen" },
            { id: 2, name: "Sel" },
            { id: 3, name: "Rab" },
            { id: 4, name: "Kam" },
            { id: 5, name: "Jum" },
            { id: 6, name: "Sab" },
        ],
        monthName: [
            { id: 1, name: "Januari" },
            { id: 2, name: "Februari" },
            { id: 3, name: "Maret" },
            { id: 4, name: "April" },
            { id: 5, name: "Mei" },
            { id: 6, name: "Juni" },
            { id: 7, name: "Juli" },
            { id: 8, name: "Agustus" },
            { id: 9, name: "September" },
            { id: 10, name: "Oktober" },
            { id: 11, name: "November" },
            { id: 12, name: "Desember" },
        ],
        disabledAdd: 'Tidak dapat dioperasikan',
        schedule: "Jadwal",
        creatSchedule: "Buat jadwal",
        editSchedule: "Edit jadwal",
        scheduleTitile: "Judul",
        scheduleDesc: "Deskripsi",
        scheduleStarttime: "Waktu mulai",
        scheduleEndtime: "Waktu selesai",
        scheduleRendertime: "Waktu pengingat",
        schedulePlace: "Lokasi",
        scheduleConfirm: "Konfirmasi",
        scheduleCancel: "Batal",
        columns: [
            { text: 'Tidak ada pengingat', value: 0 },
            { text: 'Ingatkan tepat waktu', value: 1 },
            { text: 'Ingatkan 10 menit sebelumnya', value: 10 },
            { text: 'Ingatkan 20 menit sebelumnya', value: 20 },
            { text: 'Ingatkan 30 menit sebelumnya', value: 30 },
            { text: 'Ingatkan 1 hari sebelumnya', value: 1440 },
            { text: 'Ingatkan 2 hari sebelumnya', value: 2880 },
            { text: 'Ingatkan 3 hari sebelumnya', value: 4320 },
        ],
        selDate: "Pilih tanggal",
        selTime: "Pilih waktu",
        noStart: "Belum dimulai",
        progress: "Sedang berlangsung",
        end: "Telah berakhir",
        noRemind: "Tidak ada pengingat",
        duplicateToast: "Bentrok jadwal",
        delSchedule: 'Hapus',
        noSchedule: "Tidak ada jadwal"


    },
    Xi: {
        lang: "Xi",
        hello: "¿Cómo estás?",
        today: "Hoy",
        dayword: "Frase del día",
        holiday: "Días festivos",
        holidaySub: "Las vacaciones aún están lejos...",
        confirm: "Aceptar",
        day: "día",
        days: "días",
        weeksRow: [
            { id: 0, name: "Dom" },
            { id: 1, name: "Lun" },
            { id: 2, name: "Mar" },
            { id: 3, name: "Mié" },
            { id: 4, name: "Jue" },
            { id: 5, name: "Vie" },
            { id: 6, name: "Sáb" },
        ],
        monthName: [
            { id: 1, name: "Enero" },
            { id: 2, name: "Febrero" },
            { id: 3, name: "Marzo" },
            { id: 4, name: "April" },
            { id: 5, name: "Mayo" },
            { id: 6, name: "Junio" },
            { id: 7, name: "Julio" },
            { id: 8, name: "Agosto" },
            { id: 9, name: "Septiembre" },
            { id: 10, name: "Octubre" },
            { id: 11, name: "Noviembre" },
            { id: 12, name: "Diciembre" },
        ],
        disabledAdd: 'No operativo',
        schedule: "Calendario",
        creatSchedule: "Crear evento",
        editSchedule: "Editar evento",
        scheduleTitile: "Título",
        scheduleDesc: "Descripción",
        scheduleStarttime: "Hora de inicio",
        scheduleEndtime: "Hora de finalización",
        scheduleRendertime: "Hora de recordatorio",
        schedulePlace: "Ubicación",
        scheduleConfirm: "Confirmar",
        scheduleCancel: "Cancelar",
        columns: [
            { text: 'Sin recordatorio', value: 0 },
            { text: 'Recordar a la hora exacta', value: 1 },
            { text: 'Recordar 10 minutos antes', value: 10 },
            { text: 'Recordar 20 minutos antes', value: 20 },
            { text: 'Recordar 30 minutos antes', value: 30 },
            { text: 'Recordar 1 día antes', value: 1440 },
            { text: 'Recordar 2 días antes', value: 2880 },
            { text: 'Recordar 3 días antes', value: 4320 },
        ],
        selDate: "Seleccionar fecha",
        selTime: "Seleccionar hora",
        noStart: "No iniciado",
        progress: "En curso",
        end: "Finalizado",
        noRemind: "Sin recordatorio",
        duplicateToast: "Conflicto de horarios",
        delSchedule: 'Eliminar',
        noSchedule: "No hay horarios"
    },
    En: {
        lang: "En",
        hello: "Hello",
        today: "Today",
        dayword: "A word a day",
        holiday: "Holidays",
        holidaySub: "Holidays are still far away...",
        confirm: "Certain",
        day: "day",
        days: "day",
        weeksRow: [
            { id: 0, name: "Sun" },
            { id: 1, name: "Mon" },
            { id: 2, name: "Tue" },
            { id: 3, name: "Wed" },
            { id: 4, name: "Thu" },
            { id: 5, name: "Fri" },
            { id: 6, name: "Sat" },
        ],
        monthName: [
            { id: 1, name: "January" },
            { id: 2, name: "February" },
            { id: 3, name: "March" },
            { id: 4, name: "April" },
            { id: 5, name: "May" },
            { id: 6, name: "June" },
            { id: 7, name: "July" },
            { id: 8, name: "August" },
            { id: 9, name: "September" },
            { id: 10, name: "October" },
            { id: 11, name: "November" },
            { id: 12, name: "December" },
        ],
        disabledAdd: 'Not Operable',
        schedule: "Schedule",
        creatSchedule: "Create Schedule",
        editSchedule: "Edit Schedule",
        scheduleTitile: "Title",
        scheduleDesc: "Description",
        scheduleStarttime: "Start Time",
        scheduleEndtime: "End Time",
        scheduleRendertime: "Reminder Time",
        schedulePlace: "Location",
        columns: [
            { text: 'No reminder', value: 0 },
            { text: 'Remind on time', value: 1 },
            { text: 'Remind 10 minutes early', value: 10 },
            { text: 'Remind 20 minutes early', value: 20 },
            { text: 'Remind 30 minutes early', value: 30 },
            { text: 'Remind 1 day early', value: 1440 },
            { text: 'Remind 2 day early', value: 2880 },
            { text: 'Remind 3 day early', value: 4320 },
        ],
        noStart: "Not started",
        progress: "In progress",
        end: "Finished",
        noRemind: "No reminder",
        duplicateToast: "Schedule Time Range Overlaps",
        delSchedule: 'Delete',
        noSchedule: "No Schedule Available"
    },
    Russian: {
        lang: "Russian",
        hello: "Здравствуйте",
        today: "Сегодня",
        dayword: "Ежедневная цитата",
        holiday: "Праздник ",
        holidaySub: "",
        confirm: "Подтвердить",
        day: "День",
        days: "День",
        weeksRow: [
            { id: 0, name: "Вс" },
            { id: 1, name: "Пн" },
            { id: 2, name: "Вт" },
            { id: 3, name: "Ср" },
            { id: 4, name: "Чт" },
            { id: 5, name: "Пт" },
            { id: 6, name: "Сб" },
        ],
        monthName: [
            { id: 1, name: "Январь" },
            { id: 2, name: "Февраль" },
            { id: 3, name: "Март" },
            { id: 4, name: "Апрель" },
            { id: 5, name: "Май" },
            { id: 6, name: "Июнь" },
            { id: 7, name: "Июль" },
            { id: 8, name: "Август" },
            { id: 9, name: "Сентябрь" },
            { id: 10, name: "Октябрь" },
            { id: 11, name: "Ноябрь" },
            { id: 12, name: "Декабрь" },
        ],
        disabledAdd: 'Неоперабельно',
        schedule: "Расписание",
        creatSchedule: "Создать расписание",
        editSchedule: "Редактировать расписание",
        scheduleTitile: "Заголовок",
        scheduleStarttime: "Время начала",
        scheduleEndtime: "Время окончания",
        scheduleRendertime: "Время напоминания",
        schedulePlace: "Место",
        scheduleDesc: "Описание",
        columns: [
            { text: 'Без напоминания', value: 0 },
            { text: 'Напомнить вовремя', value: 1 },
            { text: 'Напомнить за 10 минут', value: 10 },
            { text: 'Напомнить за 20 минут', value: 20 },
            { text: 'Напомнить за 30 минут', value: 30 },
            { text: 'Напомнить за 1 день', value: 1440 },
            { text: 'Напомнить за 2 день', value: 2880 },
            { text: 'Напомнить за 3 день', value: 4320 },
        ],
        noStart: "Не начато",
        progress: "В процессе",
        end: "Завершено",
        noRemind: "Без напоминания",
        duplicateToast: "Временные рамки расписания пересекаются",
        delSchedule: 'Удалить',
        noSchedule: "Нет доступного расписания"
    },
    French: {
        lang: "French",
        hello: "Bonjour",
        today: "Aujourd'hui",
        dayword: "Citation quotidienne",
        holiday: "Vacances",
        holidaySub: "",
        confirm: "Confirmer",
        day: "Jour",
        days: "Jour",
        weeksRow: [
            { id: 0, name: "Dim" },
            { id: 1, name: "Lun" },
            { id: 2, name: "Mar" },
            { id: 3, name: "Mer" },
            { id: 4, name: "Jeu" },
            { id: 5, name: "Ven" },
            { id: 6, name: "Sam" },
        ],
        monthName: [
            { id: 1, name: "Janvier" },
            { id: 2, name: "Février" },
            { id: 3, name: "Mars" },
            { id: 4, name: "Avril" },
            { id: 5, name: "Mai" },
            { id: 6, name: "Juin" },
            { id: 7, name: "Juillet" },
            { id: 8, name: "Août" },
            { id: 9, name: "Septembre" },
            { id: 10, name: "Octobre" },
            { id: 11, name: "Novembre" },
            { id: 12, name: "Décembre" },
        ],
        disabledAdd: 'Non opérable',
        schedule: "Emploi du temps",
        creatSchedule: "Créer un emploi du temps",
        editSchedule: "Modifier l'emploi du temps",
        scheduleTitile: "Titre",
        scheduleDesc: "Description",
        scheduleStarttime: "Heure de début",
        scheduleEndtime: "Heure de fin",
        scheduleRendertime: "Heure de rappel",
        schedulePlace: "Lieu",
        columns: [
            { text: 'Pas de rappel', value: 0 },
            { text: "Rappeler à l'heure", value: 1 },
            { text: "Rappeler 10 minutes à l'avance", value: 10 },
            { text: "Rappeler 20 minutes à l'avance", value: 20 },
            { text: "Rappeler 30 minutes à l'avance", value: 30 },
            { text: "Rappeler 1 jour à l'avance", value: 1440 },
            { text: "Rappeler 2 jour à l'avance", value: 2880 },
            { text: "Rappeler 3 jour à l'avance", value: 4320 },
        ],
        noStart: "Pas commencé",
        progress: "En cours",
        end: "Terminé",
        noRemind: "Pas de rappel",
        duplicateToast: "Plage horaire du programme se chevauche",
        delSchedule: 'Supprimer',
        noSchedule: "Aucun emploi du temps disponible"
    },
    Italy: {
        lang: "Italy",
        hello: "Ciao",
        today: "Oggi",
        dayword: "Citazione quotidiana",
        holiday: "Vacanza",
        holidaySub: " ",
        confirm: "Confermare",
        day: "Giorno",
        days: "Giorno",
        weeksRow: [
            { id: 0, name: "Dom" },
            { id: 1, name: "Lun" },
            { id: 2, name: "Mar" },
            { id: 3, name: "Mer" },
            { id: 4, name: "Gio" },
            { id: 5, name: "Ven" },
            { id: 6, name: "Sab" },
        ],
        monthName: [
            { id: 1, name: "Gennaio" },
            { id: 2, name: "Febbraio" },
            { id: 3, name: "Marzo" },
            { id: 4, name: "Aprile" },
            { id: 5, name: "Maggio" },
            { id: 6, name: "Giugno" },
            { id: 7, name: "Luglio" },
            { id: 8, name: "Agosto" },
            { id: 9, name: "Settembre" },
            { id: 10, name: "Ottobre" },
            { id: 11, name: "Novembre" },
            { id: 12, name: "Dicembre" },
        ],
        disabledAdd: 'Non operabile',
        schedule: "Programma",
        creatSchedule: "Crea programma",
        editSchedule: "Modifica programma",
        scheduleTitile: "Titolo",
        scheduleDesc: "Descrizione",
        scheduleStarttime: "Ora di inizio",
        scheduleEndtime: "Ora di fine",
        scheduleRendertime: "Ora di promemoria",
        schedulePlace: "Luogo",
        columns: [
            { text: 'Nessun promemoria', value: 0 },
            { text: 'Ricorda in orario', value: 1 },
            { text: 'Ricorda 10 minuti prima', value: 10 },
            { text: 'Ricorda 20 minuti prima', value: 20 },
            { text: 'Ricorda 30 minuti prima', value: 30 },
            { text: 'Ricorda 1 giorno prima', value: 1440 },
            { text: 'Ricorda 2 giorno prima', value: 2880 },
            { text: 'Ricorda 3 giorno prima', value: 4320 },
        ],
        noStart: "Non iniziato",
        progress: "In corso",
        end: "Finito",
        noRemind: "Nessun promemoria",
        duplicateToast: "Intervallo di tempo del programma si sovrappone",
        delSchedule: 'Elimina',
        noSchedule: "Nessun programma disponibile"
    },
    Portugal: {
        lang: "Portugal",
        hello: "Olá",
        today: "Hoje",
        dayword: "Citação diária",
        holiday: "Férias",
        holidaySub: " ",
        confirm: "Confirmar",
        day: "Dia",
        days: "Dia",
        weeksRow: [
            { id: 0, name: "Dom" },
            { id: 1, name: "Seg" },
            { id: 2, name: "Ter" },
            { id: 3, name: "Qua" },
            { id: 4, name: "Qui" },
            { id: 5, name: "Sex" },
            { id: 6, name: "Sáb" },
        ],
        monthName: [
            { id: 1, name: "Janeiro" },
            { id: 2, name: "Fevereiro" },
            { id: 3, name: "Março" },
            { id: 4, name: "Abril" },
            { id: 5, name: "Maio" },
            { id: 6, name: "Junho" },
            { id: 7, name: "Julho" },
            { id: 8, name: "Agosto" },
            { id: 9, name: "Setembro" },
            { id: 10, name: "Outubro" },
            { id: 11, name: "Novembro" },
            { id: 12, name: "Dezembro" },
        ],
        disabledAdd: 'Não operável',
        schedule: "Agenda",
        creatSchedule: "Criar agenda",
        editSchedule: "Editar agenda",
        scheduleTitile: "Título",
        scheduleDesc: "Descrição",
        scheduleStarttime: "Hora de início",
        scheduleEndtime: "Hora de término",
        scheduleRendertime: "Hora de lembrete",
        schedulePlace: "Local",
        columns: [
            { text: 'Sem lembrete', value: 0 },
            { text: 'Lembrar na hora', value: 1 },
            { text: 'Lembrar 10 minutos antes', value: 10 },
            { text: 'Lembrar 20 minutos antes', value: 20 },
            { text: 'Lembrar 30 minutos antes', value: 30 },
            { text: 'Lembrar 1 dia antes', value: 1440 },
            { text: 'Lembrar 2 dia antes', value: 2880 },
            { text: 'Lembrar 3 dia antes', value: 4320 },
        ],
        noStart: "Não iniciado",
        progress: "Em andamento",
        end: "Concluído",
        noRemind: "Sem lembrete",
        duplicateToast: "Intervalo de tempo da agenda se sobrepõe",
        delSchedule: 'Excluir',
        noSchedule: "Nenhuma agenda disponível"
    },
    Turkish: {
        lang: "Turkish",
        hello: "Merhaba",
        today: "Bugün",
        dayword: "Günlük alıntı",
        holiday: "Tatil",
        holidaySub: " ",
        confirm: "Onaylamak",
        day: "Gün",
        days: "Gün",
        weeksRow: [
            { id: 0, name: "Paz" },
            { id: 1, name: "Pzt" },
            { id: 2, name: "Sal" },
            { id: 3, name: "Çar" },
            { id: 4, name: "Per" },
            { id: 5, name: "Cum" },
            { id: 6, name: "Cts" },
        ],
        monthName: [
            { id: 1, name: "Ocak" },
            { id: 2, name: "Şubat" },
            { id: 3, name: "Mart" },
            { id: 4, name: "Nisan" },
            { id: 5, name: "Mayıs" },
            { id: 6, name: "Haziran" },
            { id: 7, name: "Temmuz" },
            { id: 8, name: "Ağustos" },
            { id: 9, name: "Eylül" },
            { id: 10, name: "Ekim" },
            { id: 11, name: "Kasım" },
            { id: 12, name: "Aralık" },
        ],
        disabledAdd: 'İşlem yapılamaz',
        schedule: "Program",
        creatSchedule: "Program oluştur",
        editSchedule: "Programı düzenle",
        scheduleTitile: "Başlık",
        scheduleDesc: "Açıklama",
        scheduleStarttime: "Başlangıç saati",
        scheduleEndtime: "Bitiş saati",
        scheduleRendertime: "Hatırlatma saati",
        schedulePlace: "Konum",
        columns: [
            { text: 'Hatırlatma yok', value: 0 },
            { text: 'Zamanında hatırlat', value: 1 },
            { text: '10 dakika önce hatırlat', value: 10 },
            { text: '20 dakika önce hatırlat', value: 20 },
            { text: '30 dakika önce hatırlat', value: 30 },
            { text: '1 gün önce hatırlat', value: 1440 },
            { text: '2 gün önce hatırlat', value: 2880 },
            { text: '3 gün önce hatırlat', value: 4320 },
        ],
        noStart: "Başlamadı",
        progress: "Devam ediyor",
        end: "Tamamlandı",
        noRemind: "Hatırlatma yok",
        duplicateToast: "Program zaman aralığı çakışıyor",
        delSchedule: 'Sil',
        noSchedule: "Mevcut program yok"
    },
    German: {
        lang: "German",
        hello: "Hallo",
        today: "Heute",
        dayword: "Tägliches Zitat",
        holiday: "Urlaub",
        holidaySub: "Holidays are still far away...",
        confirm: "Bestätigen",
        day: "Tag",
        days: "Tag",
        weeksRow: [
            { id: 0, name: "So" },
            { id: 1, name: "Mo" },
            { id: 2, name: "Di" },
            { id: 3, name: "Mi" },
            { id: 4, name: "Do" },
            { id: 5, name: "Fr" },
            { id: 6, name: "Sa" },
        ],
        monthName: [
            { id: 1, name: "Januar" },
            { id: 2, name: "Februar" },
            { id: 3, name: "März" },
            { id: 4, name: "April" },
            { id: 5, name: "Mai" },
            { id: 6, name: "Juni" },
            { id: 7, name: "Juli" },
            { id: 8, name: "August" },
            { id: 9, name: "September" },
            { id: 10, name: "Oktober" },
            { id: 11, name: "November" },
            { id: 12, name: "Dezember" },
        ],
        disabledAdd: 'Nicht bedienbar',
        schedule: "Zeitplan",
        creatSchedule: "Zeitplan erstellen",
        editSchedule: "Zeitplan bearbeiten",
        scheduleTitile: "Titel",
        scheduleDesc: "Beschreibung",
        scheduleStarttime: "Startzeit",
        scheduleEndtime: "Endzeit",
        scheduleRendertime: "Erinnerungszeit",
        schedulePlace: "Ort",
        columns: [
            { text: 'Keine Erinnerung', value: 0 },
            { text: 'Pünktlich erinnern', value: 1 },
            { text: '10 Minuten vorher erinnern', value: 10 },
            { text: '20 Minuten vorher erinnern', value: 20 },
            { text: '30 Minuten vorher erinnern', value: 30 },
            { text: '1 Tag vorher erinnern', value: 1440 },
            { text: '2 Tag vorher erinnern', value: 2880 },
            { text: '3 Tag vorher erinnern', value: 4320 },
        ],
        noStart: "Nicht begonnen",
        progress: "In Bearbeitung",
        end: "Beendet",
        noRemind: "Keine Erinnerung",
        duplicateToast: "Zeitbereich des Zeitplans überschneidet sich",
        delSchedule: 'Löschen',
        noSchedule: "Kein Zeitplan verfügbar"
    },
}
export const getLang = () => {
    let obj = langList['Russian']
    let customLang = ''
    let customColor = ""
    let customArr = import.meta.env && import.meta.env.VITE_CUSTOM_ARR.split(",")
    customArr.forEach(item => {
        if (item.includes("VITE_CAN_COLOR")) {
            customColor = item.split("=")?.[1]
            obj.customColor = customColor
        }

        if (item.includes("VITE_CUSTOM_LANG")) {
            customLang = item.split("=")?.[1]
        }
    });
    if (customLang) {
        obj = langList[customLang]
    }
    console.log("can", obj)
    return obj

}